<style lang="scss" scoped>
  .card-icon-plus-call-action {
    display: flex;
    align-items: center;
    justify-content: center;

    > .link {
      border: 0;
      background-color: transparent;

      &,
      &:link,
      &:hover,
      &:focus,
      &:active,
      &:visited {
        text-decoration: none;
        border: 0;
        outline: none;
      }

      > .icon {
        display: flex;
        width: 67px;
        height: 67px;
        box-shadow: 0 5px 20px rgba(165, 131, 224, 0.18);
        background-color: #ffffff;
        align-items: center;
        justify-content: center;
        border-radius: 100%;
        margin: 0 auto;
        color: #130f19;
        font-size: 1.25rem;
      }
      > .text {
        display: block;
        padding-top: 0.75rem;
        color: #3b334a;
        font-family: Montserrat;
        font-size: 14px;
        font-weight: 400;
        letter-spacing: -0.21px;
      }
    }
  }
</style>

<template>
  <div class="card card-icon-plus-call-action">
    <Component
      class="link"
      :is="componentAction"
      v-bind="$attrs"
      @click="$emit('click')"
    >
      <span class="icon"><i class="fa fa-plus" /></span><span class="text">
        <slot /></span>
    </Component>
  </div>
</template>

<script>
export default {
  name: 'CardIconPlusCallAction',

  props: {
    componentAction: {
      required: false,
      type: String,
      default: 'button',
    },
  },
};
</script>
